const ALLOWED_FONT_ORIGINS = ['https://fonts.googleapis.com', 'https://fonts.gstatic.com', 'https://use.typekit.net', 'https://cdn.glomopay.com'];

const isAllowedFontOrigin = (url: string): boolean => {
  try {
    const parsed = new URL(url);
    return ALLOWED_FONT_ORIGINS.some((origin) => parsed.origin === origin);
  } catch {
    return false;
  }
};

/** Injects a <link> for the tenant's hosted font CSS. Only trusted CDN origins are allowed. */
export const loadTenantFont = (fontsCssUrl: string): Promise<void> => {
  if (!isAllowedFontOrigin(fontsCssUrl)) {
    return Promise.reject(new Error(`Font URL origin not allowed: ${fontsCssUrl}`));
  }

  return new Promise((resolve, reject) => {
    const existingLink = document.querySelector(`link[href="${CSS.escape(fontsCssUrl)}"]`);
    if (existingLink) {
      resolve();
      return;
    }

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = fontsCssUrl;
    link.onload = () => resolve();
    link.onerror = () => reject(new Error(`Failed to load font CSS: ${fontsCssUrl}`));

    document.head.appendChild(link);
  });
};
